module.exports = __webpack_public_path__ + "img/Picture7.99f3a4da.png";